import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueSwal from "vue-swal";
import VueMask from "v-mask";
import loaddingPage from "./components/global/loadding";
import { BarcodesInstaller } from "@progress/kendo-barcodes-vue-wrapper";
import "./style/main.css";

Vue.use(BarcodesInstaller);
Vue.use(VueMask);
Vue.use(VueSwal);
Vue.component("loaddingPage", loaddingPage);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
